import { GetTargetingValuesForProviderResponse } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';

import { ActionType, createAsyncAction } from 'typesafe-actions';

export const requestTargetingParametersAsyncAction = createAsyncAction(
  '@targetingParameters/GET_TARGETING_PARAMETERS_REQUEST',
  '@targetingParameters/GET_TARGETING_PARAMETERS_SUCCESS',
  '@targetingParameters/GET_TARGETING_PARAMETERS_FAILURE',
)<
  {
    safeRefresh?: boolean;
  },
  GetTargetingValuesForProviderResponse,
  Error
>();

export type TargetingParametersActions = ActionType<typeof requestTargetingParametersAsyncAction>;
